import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import { getBenefitFlyers, getCompanySuppliersUrl } from '../../../../BCMOrder/APIs/API';

export const getCompanySuppliersAction = async (
  module = 'default',
  params = {},
) => {
  return new Promise(async (next) => {
    let token = await getToken();
    if (params instanceof URLSearchParams) {
      params.append('module', module);
    } else {
      params = new URLSearchParams(params);
      params.append('module', module);
    }
    await axios
      .get(getCompanySuppliersUrl(), {
        ...getTokenHeader(token),
        params: params,
      })
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getFlyersBasedOnRole = async (company_Value) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getBenefitFlyers()}?manufacturer_id=${company_Value}`,
        getTokenHeader(token),
      )
      .then(async (response) => {
        return next(response.data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};